export default __webpack_public_path__ + "static/media/59t.d655a343.jpg";